module.exports = __webpack_public_path__ + "static/media/05.a18c6a8f.png";